export const IMPORT_DESTINATION_FIELDS = [
  { value: "name", label: "Nombre", required: true, description: "Nombre visible del ítem. Es obligatorio." },
  { value: "description", label: "Descripción", description: "Detalle comercial o interno del ítem." },
  { value: "category", label: "Categoría", description: "Agrupación principal del catálogo." },
  { value: "subcategory", label: "Subcategoría", description: "Segundo nivel de clasificación, opcional." },
  { value: "price", label: "Precio", description: "Precio de venta. Admite coma o punto decimal." },
  {
    value: "stock",
    label: "Stock inicial / a conciliar",
    description: "Se previsualiza como existencia inicial. No se escribe directo en Product: el commit deberá registrarlo mediante movimientos ERP.",
    warning: true,
  },
  { value: "code", label: "Código", description: "Código/SKU/barcode usado para identificar el ítem y para upsert." },
  { value: "unit", label: "Unidad", description: "Unidad de medida o venta, por ejemplo un., kg o lt." },
  { value: "itemKind", label: "Tipo de ítem", description: "Producto, servicio, insumo, gasto, activo o cargo." },
  { value: "active", label: "Activo", description: "Define si el ítem queda habilitado." },
  { value: "publicVisible", label: "Visible públicamente", description: "Define si puede aparecer en el catálogo público." },
  { value: "sellable", label: "Vendible", description: "Marca el ítem como disponible para ventas." },
  { value: "purchasable", label: "Comprable", description: "Marca el ítem como disponible para compras." },
];

export const IMPORT_FIELD_BY_VALUE = Object.freeze(
  Object.fromEntries(IMPORT_DESTINATION_FIELDS.map((field) => [field.value, field])),
);

const HEADER_ALIASES = {
  name: ["articulo", "artículo", "nombre", "producto", "item", "ítem", "descripcion articulo", "descripción artículo"],
  description: ["descripcion", "descripción", "detalle", "observaciones"],
  category: ["rubro", "categoria", "categoría", "familia"],
  subcategory: ["subrubro", "subcategoria", "subcategoría", "subfamilia"],
  price: ["pventa", "p venta", "p.venta", "precio", "precio venta", "venta", "importe"],
  stock: ["exist", "exist.", "existencia", "existencias", "stock", "cantidad", "saldo"],
  code: ["codbar", "cod.bar", "codigo", "código", "sku", "barcode", "codigo barra", "código barra", "codigo de barras", "código de barras"],
  unit: ["unidad", "un", "u.m.", "um", "medida"],
  itemKind: ["tipo", "tipo item", "tipo ítem", "clase"],
  active: ["activo", "habilitado", "estado"],
  publicVisible: ["publico", "público", "visible", "publicVisible"],
  sellable: ["vendible", "venta habilitada"],
  purchasable: ["comprable", "compra habilitada"],
};

function normalizeHeader(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

export function suggestImportMapping(headers = []) {
  const usedTargets = new Set();
  const mapping = {};

  headers.forEach((header) => {
    const normalized = normalizeHeader(header);
    let target = "ignore";

    for (const [candidate, aliases] of Object.entries(HEADER_ALIASES)) {
      if (usedTargets.has(candidate)) continue;
      const matched = aliases.some((alias) => {
        const normalizedAlias = normalizeHeader(alias);
        return normalized === normalizedAlias || normalized.includes(normalizedAlias);
      });
      if (matched) {
        target = candidate;
        usedTargets.add(candidate);
        break;
      }
    }

    mapping[header] = target;
  });

  return mapping;
}

export function mappedTarget(mapping = {}, target) {
  return Object.entries(mapping).find(([, value]) => value === target)?.[0] || "";
}
